/* eslint-disable no-param-reassign */
import React, {ReactElement, useEffect} from 'react';
import ButtonBase from '@mui/material/ButtonBase';
import {DropzoneOptions, useDropzone} from 'react-dropzone';
import './index.scss';

export {FileRejection, DropEvent} from 'react-dropzone';

export interface OnDragFilesParams {
  isDragAccept: boolean;
  isDragReject: boolean;
  isDragActive: boolean;
  draggedFiles: File[];
}
export interface DropzoneProps extends DropzoneOptions {
  slug?: string;
  className?: string;
  onDragFile?: (param: OnDragFilesParams) => void;
  children?: JSX.Element | JSX.Element[];
}

const Dropzone: React.FC<DropzoneProps> = (
  props: DropzoneProps
): ReactElement => {
  const dropzone = useDropzone(props);
  const {
    getRootProps,
    getInputProps,
    isDragAccept,
    isDragReject,
    isDragActive,
    draggedFiles
  } = dropzone;
  const {className, children, onDragFile} = props;
  useEffect(() => {
    onDragFile({
      isDragAccept,
      isDragReject,
      isDragActive,
      draggedFiles
    });
  }, [isDragAccept, isDragReject, isDragActive, draggedFiles]);
  let newClassName = 'dropzoneContainer';
  if (className) newClassName += ` ${className}`;
  return (
    <ButtonBase disableRipple className={newClassName} {...getRootProps()}>
      <input {...getInputProps()} />
      <>{children}</>
    </ButtonBase>
  );
};

Dropzone.defaultProps = {
  slug: null,
  className: null,
  onDragFile: null,
  children: null
};

export default Dropzone;
